import { FiBriefcase, FiX } from 'react-icons/fi';
import data from '../../JsonFolders/portfolio.json';
import { EXPERIENCE } from '../../data/profile';
import { scrollToSection } from '../../scroll/scroll';
import SectionHeading from '../SectionHeading/SectionHeading';
import './Achievement.css';

const groups = [
  ['Languages', ['Python', 'JavaScript', 'TypeScript', 'C#', 'SQL', 'HTML5']],
  ['Frontend', ['React', 'Angular', 'Bootstrap']],
  ['Backend & data', ['Node.js', '.NET', 'FastAPI', 'PostgreSQL']],
  ['AI & vision', ['PyTorch', 'TensorFlow', 'Ultralytics YOLO', 'OpenCV']],
  ['Cloud & tools', ['AWS', 'Azure', 'Docker', 'GitHub']],
];
const projects = data.images.projects;
const workTech = new Set(EXPERIENCE.flatMap((job) => [...(job.stack || []), ...job.skills]));

export default function Achievement({ techFilter, onTechFilter }) {
  const select = (name, count) => {
    if (!count) { scrollToSection('experience'); return; }
    onTechFilter(techFilter === name ? null : name);
    requestAnimationFrame(() => scrollToSection('projects'));
  };

  return (
    <section id="skills" className="section tech" aria-labelledby="tech-title">
      <div className="container">
        <SectionHeading
          title="Skills"
          id="tech-title"
          intro="Pick a tool to see the projects built with it. Everything listed is used somewhere on this site or in a role."
        />
        <div className="tech-groups">
          {groups.map(([title, names], gi) => (
            <div className="tech-group" key={title} data-reveal style={{ '--i': gi % 2 }}>
              <h3>{title}</h3>
              <div className="tech-items">
                {names.map((name) => {
                  const count = projects.filter((project) => project.stack?.includes(name)).length;
                  const atWork = workTech.has(name);
                  const hint = count ? `${count} project${count === 1 ? '' : 's'}` : atWork ? 'Used at work' : undefined;
                  return (
                    <button
                      key={name}
                      type="button"
                      className={`tech-chip ${techFilter === name ? 'is-active' : ''}`}
                      aria-pressed={count ? techFilter === name : undefined}
                      aria-label={hint ? `${name}, ${hint}` : name}
                      title={hint}
                      onClick={() => select(name, count)}
                    >
                      {name}
                      {count > 0 && <span className="tech-count tabular" aria-hidden="true">{count}</span>}
                      {!count && atWork && <FiBriefcase className="tech-work" aria-hidden="true" />}
                    </button>
                  );
                })}
              </div>
            </div>
          ))}
        </div>
        <div className="tech-legend">
          <span><span className="tech-count tabular" aria-hidden="true">2</span> projects using it</span>
          <span><FiBriefcase aria-hidden="true" /> used at work</span>
          {techFilter && (
            <button type="button" onClick={() => onTechFilter(null)}>
              <FiX aria-hidden="true" /> Clear the {techFilter} filter
            </button>
          )}
        </div>
      </div>
    </section>
  );
}
